import React, { useState } from "react";
import { Card, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldAlt, faUsers, faClock, faBan, faPlus } from "@fortawesome/free-solid-svg-icons";
import BlocageBouleTable from "./blocage_boule_table";

export function BlocageBoule() {
  const [activeTab, setActiveTab] = useState("general");
  const [triggerNewBlockage, setTriggerNewBlockage] = useState(0);

  const data = [
    {
      label: "Général",
      value: "general",
      icon: faShieldAlt,
      desc: "Blocages globaux appliqués à toute l'entreprise (tous tirages)",
      targetLevel: "GENERAL",
    },
    {
      label: "Agents",
      value: "agent",
      icon: faUsers,
      desc: "Blocages spécifiques par agent",
      targetLevel: "AGENT",
    },
    {
      label: "Succursales",
      value: "branch",
      icon: faUsers,
      desc: "Blocages spécifiques par succursale",
      targetLevel: "BRANCH",
    },
    {
      label: "Tirage",
      value: "tirage",
      icon: faClock,
      desc: "Blocages globaux appliqués à un tirage spécifique",
      targetLevel: "TIRAGE",
    },
  ];

  const currentTabData = data.find(d => d.value === activeTab) || data[0];

  return (
    <div style={{ padding: '16px 0' }}>
      <Card className="border-0 shadow-sm" style={{ borderRadius: '8px' }}>
        <Card.Header className="bg-white border-0 pt-4 pb-0">
          <div className="d-flex justify-content-between align-items-center">
            <h4 style={{ fontWeight: 'bold', color: '#333', margin: 0 }}>Blocage Boule</h4>
            <Button
                variant="primary"
                style={{
                    borderRadius: '4px',
                    fontSize: '0.88rem',
                    padding: '6px 20px',
                    fontWeight: '500',
                    color: '#FFF'
                }}
                onClick={() => setTriggerNewBlockage(prev => prev + 1)}
            >
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                Nouveau Blocage
            </Button>
          </div>
        </Card.Header>

        <Card.Body>
          {/* Top navigation tabs/buttons in Volt style */}
          <div className="d-flex mb-4 flex-wrap" style={{ gap: '10px' }}>
            {data.map(({ label, value, icon }) => (
              <Button
                key={value}
                style={{
                  backgroundColor: activeTab === value ? '#007BFF' : 'transparent',
                  borderColor: '#007BFF',
                  color: activeTab === value ? '#FFF' : '#007BFF',
                  borderRadius: '4px',
                  fontSize: '0.85rem',
                  padding: '6px 16px',
                  fontWeight: '500'
                }}
                onClick={() => setActiveTab(value)}
              >
                <FontAwesomeIcon icon={icon} className="me-2" />
                {label}
              </Button>
            ))}
          </div>

          <BlocageBouleTable 
            targetLevel={currentTabData.targetLevel} 
            title={`Gestion Blocage - ${currentTabData.label}`}
            description={currentTabData.desc}
            triggerNewBlockage={triggerNewBlockage}
            mode="blocage"
          />
        </Card.Body>
      </Card>
    </div>
  );
}

export default BlocageBoule;
